export {default as IDisplayObjectAdapter}			from "./adapters/IDisplayObjectAdapter";
export {default as IMovieClipAdapter}				from "./adapters/IMovieClipAdapter";